import { decode, encode } from "base64-arraybuffer";
import utf8 from "utf8";

export const isNumber = (value) => {
  return typeof value === "number";
};

export const isObject = (value) => {
  return typeof value === "object";
};

export const isArray = (value) => {
  return Array.isArray(value);
};

export const isNullish = (value) => {
  return value === undefined || value === null;
};

export const isNonNullish = (value) => {
  return !isNullish(value);
};

export const isNonEmptyString = (value) => {
  return isNonNullish(value) && value !== "";
};

export const isEmptyString = (value) => {
  return !isNonEmptyString(value);
};

//------------------------------------------------------------------------

// https://stackoverflow.com/questions/4647817/javascript-object-rename-key
export const changeKey = (element, keyOld, keyNew) => {
  if (keyOld !== keyNew) {
    Object.defineProperty(element, keyNew, Object.getOwnPropertyDescriptor(element, keyOld));
    delete element[keyOld];
  }
};

export const createDeepCopy = (element) => {
  return JSON.parse(JSON.stringify(element));
};

export const removeDuplicates = (array) => {
  return [...new Set(array)];
};

export const encBase64 = (data) => {
  return btoa(utf8.encode(data));
};

//------------------------------------------------------------------------

export const encGzipBase64 = async (txtData) => {
  const binPlain = txtToBinUTF8(txtData);
  const binCompressed = await compress(binPlain, "gzip");
  const txtCompressed = binToTxtB64(binCompressed);

  return txtCompressed;
};

export const decGzipBase64 = async (txtData) => {
  const binCompressed = txtToBinB64(txtData);
  const binDecompressed = await decompress(binCompressed, "gzip");
  const txtPlain = binToTxtUTF8(binDecompressed);

  return txtPlain;
};

const compress = async (binData, algorithm) => {
  return await processStream(new CompressionStream(algorithm), binData);
};

const decompress = async (binData, algorithm) => {
  return await processStream(new DecompressionStream(algorithm), binData);
};

const txtToBinUTF8 = (txtData) => {
  return new TextEncoder().encode(txtData);
};

const binToTxtUTF8 = (binData) => {
  return new TextDecoder().decode(binData);
};

const txtToBinB64 = (txtData) => {
  return decode(txtData);
};

const binToTxtB64 = (binData) => {
  return encode(binData);
};

const processStream = async (stream, data) => {
  const writer = stream.writable.getWriter();

  writer.write(data);
  writer.close();

  return await new Response(stream.readable).arrayBuffer();
};

export const compressionTest = async (txtData) => {
  const decDataLength = txtData.length;

  const compressed = await encGzipBase64(txtData);

  const encDataLength = compressed.length;

  const decompressed = await decGzipBase64(compressed);

  const results = `TEST / CMP - Validation:        ${decompressed === txtData}
TEST / CMP - Size original:     ${decDataLength}
TEST / CMP - Size compressed:   ${encDataLength}
TEST / CMP - Compression ratio: ${1 - encDataLength / decDataLength}
`;

  return results;
};

//------------------------------------------------------------------------

export const downloadFile = (text, name) => {
  const blob = new Blob([text], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.download = name;
  link.href = url;

  link.click();
};

export const readTextFromFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = (e) => {
      resolve(e.target.result);
    };

    reader.onerror = (e) => {
      reject(e);
    };

    reader.readAsText(file);
  });
};

export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
};

//------------------------------------------------------------------------

export const saveToSessionStorage = (key, value) => {
  sessionStorage.setItem(key, value);
};

export const loadFromSessionStorage = (key) => {
  return sessionStorage.getItem(key);
};

export const removeFromSessionStorage = (key) => {
  sessionStorage.removeItem(key);
};

export const clearSessionStorage = () => {
  sessionStorage.clear();
};

export const saveToLocalStorage = (key, value) => {
  localStorage.setItem(key, value);
};

export const loadFromLocalStorage = (key) => {
  return localStorage.getItem(key);
};

export const removeFromLocalStorage = (key) => {
  localStorage.removeItem(key);
};

export const clearLocalStorage = () => {
  localStorage.clear();
};

export const isEnvDev = () => {
  return loadFromLocalStorage("env") === "dev";
};

export const loadFromEnv = (key) => {
  return process.env[key];
};

//------------------------------------------------------------------------

export const getTimestamp = () => {
  return Date.now();
};

// const downloadCSV = async () => {
//   if (window.showSaveFilePicker) {
//     try {
//       const opts = {
//         types: [{
//           description: 'CSV Files',
//           accept: {'text/csv': ['.csv']},
//         }],
//       };
//       const handle = await window.showSaveFilePicker(opts);
//       const writable = await handle.createWritable();
//       await writable.write(generatedData);
//       await writable.close();
//     } catch (err) {
//       console.error('Error saving file:', err);
//     }
//   } else {
//     // Fallback for browsers that do not support the File System Access API
//     const blob = new Blob([generatedData], { type: 'text/csv;charset=utf-8;' });
//     const link = document.createElement('a');
//     link.href = URL.createObjectURL(blob);
//     link.setAttribute('download', 'generated_data.csv');
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   }
// };
